import * as yup from 'yup';
import { CalculatorOptions } from '../CompoundPage.hooks';

export const INITIAL_VALUES: CalculatorOptions = {
  initialAmount: 0,
  investFrequency: 1,
  frequentInvestment: 1000000,
  period: 20,
  interestPercentage: 7,
};

export const investFrequencyMap = {
  1: '매월',
  4: '매분기',
  12: '매년',
};

export const schema = yup.object().shape({
  initialAmount: yup.number().required('초기 투자금을 입력해주세요.'),
  investFrequency: yup
    .number()
    .oneOf([1, 4, 12])
    .required('투자 주기를 선택해주세요.'),
  frequentInvestment: yup.number().optional().default(0),
  period: yup.number().min(1).required('투자기간을 입력해주세요.'),
  interestPercentage: yup.number().min(0.1).required('연 수익률을 입력해주세요.'),
});
